import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { BATTLESHIP, OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { useState } from 'react';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import SkeletonWrappedFormattedMessage from '../common/i18n/SkeletonWrappedFormattedMessage';
import { TranslationsContext } from './Faq';
const QuestionContainer = styled.div.withConfig({
  displayName: "Question__QuestionContainer",
  componentId: "y2j4sq-0"
})(["margin-top:15px;margin-left:25px;margin-right:30px;background-color:", ";", ""], OLAF, breakpoint.phone(_t || (_t = _`
    margin: 15px 0 0;
  `)));
const QuestionOutlineBorder = styled(UIExpandableSection).withConfig({
  displayName: "Question__QuestionOutlineBorder",
  componentId: "y2j4sq-1"
})(["border-width:0 0.5px 0.5px 1px;border-style:solid;border-color:", ";"], BATTLESHIP);
const Br = styled.br.withConfig({
  displayName: "Question__Br",
  componentId: "y2j4sq-2"
})(["line-height:40px;"]);
const Bold = styled.span.withConfig({
  displayName: "Question__Bold",
  componentId: "y2j4sq-3"
})(["font-weight:bold;"]);

const Question = ({
  questionKey,
  getHref,
  onClick,
  onQuestionClick = () => {},
  getPassedInOptions = () => ({}),
  isJSX = true,
  externalLink = true
}) => {
  const href = getHref && getHref();
  const passedInOptions = getPassedInOptions && getPassedInOptions();
  const [isQuestionOpen, setIsQuestionOpen] = useState(false);
  const history = useHistory();
  const currencyCode = useSelector(activeCurrencySelector);

  const handleClickQuestion = question => {
    getUsageTracker().track('faqInteraction', {
      action: isQuestionOpen ? 'closed' : 'opened',
      questionKey: question
    });
    setIsQuestionOpen(prev => !prev);
    onQuestionClick();
  };

  const handleClickLink = () => {
    if (onClick) {
      onClick();
    } else {
      getUsageTracker().track('externalLinkClick', {
        name: 'faq-click-link',
        url: href
      });

      if (!externalLink && href) {
        history.push(href);
        window.scrollTo(0, 0);
      }
    }
  };

  const QuestionLink = ({
    children
  }) => {
    return /*#__PURE__*/_jsx(UILink, {
      external: externalLink,
      href: externalLink ? href : undefined,
      onClick: handleClickLink,
      children: children
    });
  };

  return /*#__PURE__*/_jsx(QuestionContainer, {
    children: /*#__PURE__*/_jsx(QuestionOutlineBorder, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `faq.${questionKey}.question`
      }),
      open: isQuestionOpen,
      onOpenChange: () => handleClickQuestion(questionKey),
      children: isJSX ? /*#__PURE__*/_jsx(SkeletonWrappedFormattedMessage, {
        MessageComponent: FormattedJSXMessage,
        translationsContext: TranslationsContext,
        message: `faq.${questionKey}.answer_jsx`,
        options: Object.assign({
          currencyCode
        }, passedInOptions),
        elements: {
          Link: QuestionLink,
          FormattedNumber,
          UIList,
          UILink,
          Br,
          div: (_ref) => {
            let {
              children
            } = _ref,
                rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

            return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
              children: children
            }));
          },
          Bold
        }
      }) : /*#__PURE__*/_jsx(SkeletonWrappedFormattedMessage, {
        translationsContext: TranslationsContext,
        message: `faq.${questionKey}.answer`
      })
    })
  });
};

export default Question;